if (!customElements.get("make-model-year-search")) {
  customElements.define(
    "make-model-year-search",
    class YearSearch extends HTMLElement {
      constructor() {
        super();
        this.fitmentData = [];
        this.makeFilter = this.querySelector(".select__make_data");
        this.modelFilter = this.querySelector(".select__model_data");
        this.yearFilter = this.querySelector(".select__year_data");
        this.engineFilter = this.querySelector(".select__engine_data");
        this.searchURL = this.querySelector(".search__url");

        this.selectedMake = "";
        this.selectedModel = "";
        this.selectedYear = "";

        this.makeFilter?.addEventListener("change", this.onMakeChange.bind(this));
        this.modelFilter?.addEventListener("change", this.onModelChange.bind(this));
        this.yearFilter?.addEventListener("change", this.onYearChange.bind(this));
        this.engineFilter?.addEventListener("change", this.onEngineChange.bind(this));

        this.loadAllFitmentData();
      }

      async fetchStorefront(query, variables = {}) {
        const response = await fetch(
          "https://www.metroautoonline.com.au/api/2024-01/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "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",
            },
            body: JSON.stringify({ query, variables }),
          }
        );
        return response.json();
      }

      async loadAllFitmentData() {
        const query = `
          query GetFitments($cursor: String) {
            metaobjects(type: "sidekick_ymm_fitment", first: 250, after: $cursor) {
              edges {
                node {
                  make: field(key: "make") { value }
                  model: field(key: "model") { value }
                  year: field(key: "year") { value }
                  engine_variant: field(key: "engine_variant") { value }
                  product_handle: field(key: "product_handle") { value }
                }
              }
              pageInfo { hasNextPage endCursor }
            }
          }
        `;

        let allRecords = [];
        let cursor = null;
        let hasNext = true;

        while (hasNext) {
          const result = await this.fetchStorefront(query, { cursor });
          const page = result?.data?.metaobjects;
          if (!page) break;
          allRecords.push(
            ...page.edges.map((e) => ({
              make: e.node.make?.value ?? "",
              model: e.node.model?.value ?? "",
              year: e.node.year?.value ?? "",
              engine_variant: e.node.engine_variant?.value ?? "",
              product_handle: e.node.product_handle?.value ?? "",
            }))
          );
          hasNext = page.pageInfo.hasNextPage;
          cursor = page.pageInfo.endCursor;
        }

        this.fitmentData = allRecords;
        this.populateMakes();
      }

      unique(arr) {
        return [...new Set(arr.filter(Boolean))].sort();
      }

      populateMakes() {
        const makes = this.unique(this.fitmentData.map((r) => r.make));
        let html = `<option value="select">${window.advanceSearch?.field_label_1 ?? "Select Make"}</option>`;
        makes.forEach((m) => (html += `<option value="${m}">${m}</option>`));
        if (this.makeFilter) this.makeFilter.innerHTML = html;
      }

      onMakeChange() {
        this.selectedMake = this.makeFilter.value;
        if (this.modelFilter) this.modelFilter.disabled = true;
        if (this.yearFilter) this.yearFilter.disabled = true;
        if (this.engineFilter) this.engineFilter.disabled = true;

        if (this.selectedMake === "select") return;

        const models = this.unique(
          this.fitmentData
            .filter((r) => r.make === this.selectedMake)
            .map((r) => r.model)
        );
        let html = `<option value="select">${window.advanceSearch?.field_label_2 ?? "Select Model"}</option>`;
        models.forEach((m) => (html += `<option value="${m}">${m}</option>`));
        if (this.modelFilter) {
          this.modelFilter.innerHTML = html;
          this.modelFilter.disabled = false;
        }

        this.searchURL?.setAttribute(
          "href",
          `/collections/all?filter.p.m.make.key_make=${encodeURIComponent(this.selectedMake)}`
        );
      }

      onModelChange() {
        this.selectedModel = this.modelFilter.value;
        if (this.yearFilter) this.yearFilter.disabled = true;
        if (this.engineFilter) this.engineFilter.disabled = true;

        if (this.selectedModel === "select") return;

        const years = this.unique(
          this.fitmentData
            .filter((r) => r.make === this.selectedMake && r.model === this.selectedModel)
            .map((r) => r.year)
        );
        let html = `<option value="select">${window.advanceSearch?.field_label_3 ?? "Select Year"}</option>`;
        years.forEach((y) => (html += `<option value="${y}">${y}</option>`));
        if (this.yearFilter) {
          this.yearFilter.innerHTML = html;
          this.yearFilter.disabled = false;
        }

        this.searchURL?.setAttribute(
          "href",
          `/collections/all?filter.p.m.make.key_make=${encodeURIComponent(this.selectedMake)}&filter.p.m.model.key_model=${encodeURIComponent(this.selectedModel)}`
        );
      }

      onYearChange() {
        this.selectedYear = this.yearFilter.value;
        if (this.engineFilter) this.engineFilter.disabled = true;

        if (this.selectedYear === "select") return;

        const engines = this.unique(
          this.fitmentData
            .filter(
              (r) =>
                r.make === this.selectedMake &&
                r.model === this.selectedModel &&
                r.year === this.selectedYear
            )
            .map((r) => r.engine_variant)
        );
        let html = `<option value="select">${window.advanceSearch?.field_label_4 ?? "Select Engine"}</option>`;
        engines.forEach((e) => (html += `<option value="${e}">${e}</option>`));
        if (this.engineFilter) {
          this.engineFilter.innerHTML = html;
          this.engineFilter.disabled = false;
        }

        this.searchURL?.setAttribute(
          "href",
          `/collections/all?filter.p.m.make.key_make=${encodeURIComponent(this.selectedMake)}&filter.p.m.model.key_model=${encodeURIComponent(this.selectedModel)}&filter.p.m.year.key_year=${encodeURIComponent(this.selectedYear)}`
        );
      }

      onEngineChange() {
        const engine = this.engineFilter.value;
        if (engine === "select") return;

        const match = this.fitmentData.find(
          (r) =>
            r.make === this.selectedMake &&
            r.model === this.selectedModel &&
            r.year === this.selectedYear &&
            r.engine_variant === engine
        );

        const href = match?.product_handle
          ? `/products/${match.product_handle}`
          : `/collections/all?filter.p.m.make.key_make=${encodeURIComponent(this.selectedMake)}&filter.p.m.model.key_model=${encodeURIComponent(this.selectedModel)}&filter.p.m.year.key_year=${encodeURIComponent(this.selectedYear)}`;

        this.searchURL?.setAttribute("href", href);
      }
    }
  );
}
